/**
 * Trims the league name of region prefixes.
 * Example: "International - World Cup" => "World Cup"
 */
const trimLeagueName = (leagueName: string) => {
	if (leagueName.includes(' - ')) {
		return leagueName.split(' - ').slice(1).join(' - ').trim();
	}
	return leagueName;
};

export default trimLeagueName;
